import { render, staticRenderFns } from "./DeleteAlarmSetting.vue?vue&type=template&id=34e1a188&scoped=true"
import script from "./DeleteAlarmSetting.vue?vue&type=script&lang=js"
export * from "./DeleteAlarmSetting.vue?vue&type=script&lang=js"
import style0 from "./DeleteAlarmSetting.vue?vue&type=style&index=0&id=34e1a188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e1a188",
  null
  
)

export default component.exports